var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4474 68.6839C89.7175 68.6839 92.3685 66.033 92.3685 62.7628C92.3685 59.4927 89.7175 56.8418 86.4474 56.8418C83.1773 56.8418 80.5264 59.4927 80.5264 62.7628C80.5264 66.033 83.1773 68.6839 86.4474 68.6839Z",
    fill: "#C98E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9739 86.8803L89.2425 67.9566L84.1741 57.2939L54.4741 71.0521L54.9739 86.8803Z",
    fill: "#C98E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4737 65.1313C99.4737 61.8606 96.8234 59.2103 93.5526 59.2103C92.7474 59.2103 91.98 59.3737 91.2813 59.665L91.279 59.6627L91.2529 59.6745C91.2482 59.6769 91.2434 59.6792 91.2387 59.6816L61.5789 73.4208L58.0263 71.0524C61.2971 71.0524 63.9474 68.4021 63.9474 65.1313C63.9474 62.9287 62.73 61.0292 60.9466 60.0085L60.9561 59.9706L28.6247 43.709H28.5655C27.0734 43.0316 25.4297 42.6313 23.6842 42.6313C21.9837 42.6313 20.3755 43.0032 18.9118 43.6498H18.8597L1.77273 51.3103C0.694115 51.7938 0 52.8657 0 54.0478V78.2141C0 80.4014 2.26534 81.8534 4.25277 80.94L19.1605 74.0887L56.8445 89.5024H56.8468C57.5739 89.8198 58.3697 89.9998 59.2105 89.9998C60.2408 89.9998 61.1953 89.7132 62.0408 89.249L62.0811 89.2466L96.3497 70.3253L96.3474 70.3206C98.1995 69.3211 99.4737 67.3861 99.4737 65.1313Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0268 68.6834C59.9888 68.6834 61.5794 67.0928 61.5794 65.1308C61.5794 63.1687 59.9888 61.5781 58.0268 61.5781C56.0647 61.5781 54.4741 63.1687 54.4741 65.1308C54.4741 67.0928 56.0647 68.6834 58.0268 68.6834Z",
    fill: "#FFDE87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5793 73.4203L58.0527 71.0566C55.0803 70.9145 52.7427 69.9482 33.1582 62.7363V71.0519L60.5158 82.264C60.5158 82.264 58.5785 76.8569 61.5793 73.4203Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3158 6.51316C66.3158 6.51316 72.1469 0 79.3421 0C86.5374 0 92.3685 5.91158 92.3685 13.0263C92.3685 25.2711 73.1819 39.2495 67.7392 42.9679C66.8771 43.5576 65.7545 43.5576 64.8924 42.9679C59.4498 39.2495 40.2632 25.2711 40.2632 13.0263C40.2632 5.91158 46.0942 0 53.2895 0C60.4848 0 66.3158 6.51316 66.3158 6.51316Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 66.3156,
    x2: 99.4737,
    y2: 66.3156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#FDCB4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#F7C13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B421"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 45.7985,
    y1: 74.2919,
    x2: 50.0285,
    y2: 66.9971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B421",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#E9AB12",
    stopOpacity: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 55.89,
    y1: -2.64553,
    x2: 80.3771,
    y2: 35.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.0437cb175d32e189235f18263840beed.svg";
export { ForwardRef as ReactComponent };